import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postSupportUpdateStatus = (params) => {
    return axios.post(`${backendHost}/api/admin/support/status/update`, params);
};

export {
    postSupportUpdateStatus
}